import { lazy, type LazyExoticComponent } from 'react';

import type { ActionRendererFor } from '@atlassian/conversation-assistant-message-actions-api/types';

export const ExecutePythonRendererAsync: LazyExoticComponent<
	(props: ActionRendererFor<'execute_python'>) => React.JSX.Element
> = lazy(() =>
	import(
		/* webpackChunkName: "@atlassian/conversation-assistant-message-actions/execute-python-renderer" */ './ExecutePythonRenderer'
	).then((m) => ({ default: m.ExecutePythonRenderer })),
);
